import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridListComponent } from './grid-list.component';
import { GridTileComponent } from './grid-tile.component';

@NgModule({
  imports: [CommonModule],
  declarations: [GridListComponent, GridTileComponent],
  exports: [GridListComponent, GridTileComponent],
})
export class GridListModule {}
